import { useCallback } from "react";
import { useAppDispatch } from "../../application/states/hooks";
import {
  setReportCompaniesState,
  setReportCompaniesPaginationState,
  resetReportCompaniesState,
} from "../../application/states/report-companies/report-companies-slice";
import { useReportCompaniesApi } from "../../infra/report-companies-api";
import { useLoadingService } from "../loading";
import { executeAlert } from "../../application/states/toast-alert";
import { setLurikProcessState } from "../../application/states/lurik-process";

export const useReportCompaniesService = () => {
  // Dispatch
  const dispatch = useAppDispatch();
  const { startLoading, stopLoading } = useLoadingService();
  const {
    getPeriodReportCompaniesApi,
    getStatusReportApi,
  } = useReportCompaniesApi();

  const getPeriodReportCompanies = useCallback(
    async (data: {
      userId: string;
      limit?: number;
      page?: number;
      filters?: {
        companyId?: string;
        startDate?: Date;
        endDate?: Date;
      };
    }) => {
      dispatch(
          (resetReportCompaniesState)
        );
      startLoading();

      const getReportCompaniesResult = await getPeriodReportCompaniesApi({
        userId: data.userId,
        limit: data.limit,
        page: data.page,
        filters: {
          companyId: data.filters?.companyId,
          startDate: data.filters?.startDate,
          endDate: data.filters?.endDate,
        },
      });

      if (getReportCompaniesResult) {
        dispatch(
          setLurikProcessState({
            id: getReportCompaniesResult.id,
            resourceId: getReportCompaniesResult.resourceId,
            userId: data.userId,
          })
        );
        return getReportCompaniesResult;
      } else {
        stopLoading();
        dispatch(
          executeAlert({
            message: "Erro ao buscar relatório de empresas.",
            type: "error",
          })
        );
      }
    },
    [dispatch, getPeriodReportCompaniesApi, startLoading, stopLoading]
  );

  const setReportCompaniesPagination = useCallback(
    (data: { page: number; limit: number }) => {
      dispatch(
        setReportCompaniesPaginationState({
          page: data.page,
          limit: data.limit,
        })
      );
    },
    [dispatch]
  );

  const checkReportStatus = useCallback(
    async (data: { idProcess: string; resourceId: string; userId: string }) => {
      try {
        const statusReport = await getStatusReportApi({
          userId: data.userId,
          resourceId: data.resourceId,
          idProcess: data.idProcess,
        });
        if (statusReport && statusReport.reportCompanies.length > 0) {
          stopLoading();
          dispatch(
            setReportCompaniesState({
              reportCompanies: statusReport.reportCompanies,
              idJsonFile: statusReport.idJsonFile,
              total: statusReport.total,
            })
          );
          return statusReport;
        }
        return null;
      } catch (error) {    
        return null;
      }
    },
    [getStatusReportApi, dispatch, stopLoading]
  );

  const resetReportCompanies = (
    async (data: { idProcess: string; }) => {
      dispatch(resetReportCompaniesState)
    }
  )

  return {
    getPeriodReportCompanies,
    setReportCompaniesPagination,
    checkReportStatus,
    resetReportCompanies
  };
};